module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-menu",
    class: {
      'close': _vm.close
    }
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('add')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "登録"
    }
  }), _c('span', [_vm._v("登録")])])]), _vm._v(" "), (_vm.add) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_vm._m(0)] : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointments/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "AP登録"
    }
  }), _c('span', [_vm._v("AP登録")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/families/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "家庭登録"
    }
  }), _c('span', [_vm._v("家庭登録")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/students/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "生徒登録"
    }
  }), _c('span', [_vm._v("生徒登録")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutors/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "先生登録"
    }
  }), _c('span', [_vm._v("先生登録")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/agreements/add"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "契約情報登録"
    }
  }), _c('span', [_vm._v("契約情報登録")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('list')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "リスト"
    }
  }), _c('span', [_vm._v("リスト")])])]), _vm._v(" "), (_vm.list) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/users",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-address-card",
    attrs: {
      "title": "Users"
    }
  }), _c('span', [_vm._v("ユーザーリスト")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/advisors"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-group",
    attrs: {
      "title": "アドバイザー"
    }
  }), _c('span', [_vm._v("アドバイザー")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointments",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car",
    attrs: {
      "title": "APリスト"
    }
  }), _c('span', [_vm._v("APリスト")])])], 1), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.office_id === 1 || _vm.user.office_id === 4) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointments2",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "APリストⅡ"
    }
  }), _c('span', [_vm._v("APリストⅡ")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointments/confirms",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car",
    attrs: {
      "title": "確認リスト"
    }
  }), _c('span', [_vm._v("確認リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/families",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-home",
    attrs: {
      "title": "家庭リスト"
    }
  }), _c('span', [_vm._v("家庭リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/students",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-child",
    attrs: {
      "title": "生徒リスト"
    }
  }), _c('span', [_vm._v("生徒リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutors",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "先生リスト"
    }
  }), _c('span', [_vm._v("先生リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutors2",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "先生リストⅡ"
    }
  }), _c('span', [_vm._v("先生リストⅡ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/agreements",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-handshake-o",
    attrs: {
      "title": "契約リスト"
    }
  }), _c('span', [_vm._v("契約リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutor_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "tutor_channels"
    }
  }), _c('span', [_vm._v("家庭教師登録媒体リスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/students/inheritance"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "引継リスト"
    }
  }), _c('span', [_vm._v("引継リスト")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('support')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "対応履歴"
    }
  }), _c('span', [_vm._v("対応履歴")])])]), _vm._v(" "), (_vm.support) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointmentsupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "AP対応履歴"
    }
  }), _c('span', [_vm._v("AP対応履歴")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/familysupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "家庭対応履歴"
    }
  }), _c('span', [_vm._v("家庭対応履歴")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutorsupports"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "先生対応履歴"
    }
  }), _c('span', [_vm._v("先生対応履歴")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "PDF"
    }
  }), _c('span', [_vm._v("PDF")])])]), _vm._v(" "), (_vm.file) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/familyfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "家庭ファイル"
    }
  }), _c('span', [_vm._v("家庭ファイル")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/studentfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "生徒ファイル"
    }
  }), _c('span', [_vm._v("生徒ファイル")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tutorfiles"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "先生ファイル"
    }
  }), _c('span', [_vm._v("先生ファイル")])])], 1)] : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.office_id === 1) ? [_vm._m(3)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.office_id === 1 || _vm.user.office_id === 3) ? [_vm._m(4)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('other')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "その他"
    }
  }), _c('span', [_vm._v("その他")])])]), _vm._v(" "), (_vm.other) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/student_tutors"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-text",
    attrs: {
      "title": "探しデータ"
    }
  }), _c('span', [_vm._v("探しデータ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/documents"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-book",
    attrs: {
      "title": "documents"
    }
  }), _c('span', [_vm._v("documents")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/tags"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tags",
    attrs: {
      "title": "タグリスト"
    }
  }), _c('span', [_vm._v("タグリスト")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/todos"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square",
    attrs: {
      "title": "Todoリスト"
    }
  }), _c('span', [_vm._v("Todoリスト")])])], 1), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "channels"
    }
  }), _c('span', [_vm._v("教師登録媒体")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'mgr') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/office_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-graduation-cap",
    attrs: {
      "title": "channels"
    }
  }), _c('span', [_vm._v("教師登録媒体カスタム")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/appointment_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exclamation-triangle",
    attrs: {
      "title": "appointment_channels"
    }
  }), _c('span', [_vm._v("appointment_channels")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/versions"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-history",
    attrs: {
      "title": "変更履歴"
    }
  }), _c('span', [_vm._v("変更履歴")])])], 1)] : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('aggregate')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計"
    }
  }), _c('span', [_vm._v("集計")])])]), _vm._v(" "), (_vm.aggregate) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/appointments"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-AP"
    }
  }), _c('span', [_vm._v("集計-AP")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/appointments_month"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-月間CV"
    }
  }), _c('span', [_vm._v("集計-月間CV")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/appointments_month2"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-月間AP"
    }
  }), _c('span', [_vm._v("集計-月間AP")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/tutor_channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-家庭教師"
    }
  }), _c('span', [_vm._v("集計-家庭教師")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting' || _vm.user.type === 'mgr' || _vm.user.id === 377) ? [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.childOpen('keiri')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "経理"
    }
  }), _c('span', [_vm._v("経理")])])]), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_vm._m(5)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "契約情報"
    }
  }), _c('span', [_vm._v("契約情報")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting' || _vm.user.id === 526 || _vm.user.id === 377 || _vm.user.id === 75 || _vm.user.id === 620 || _vm.user.id === 653 || _vm.user.id === 627 || _vm.user.id === 612 || _vm.user.id === 520 || _vm.user.id === 121) ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/paymentdetails"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "テキスト支払"
    }
  }), _c('span', [_vm._v("テキスト支払")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'act' || _vm.user.type === 'accounting' || _vm.user.id === 526 || _vm.user.id === 377 || _vm.user.id === 75 || _vm.user.id === 620 || _vm.user.id === 653 || _vm.user.id === 627 || _vm.user.id === 612 || _vm.user.id === 520 || _vm.user.id === 121) ? [_c('li'), _c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/paymentdetails2s"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "管理費支払"
    }
  }), _c('span', [_vm._v("管理費支払")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'accounting') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/contracts_month"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-月間売上"
    }
  }), _c('span', [_vm._v("集計-月間売上")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'accounting') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-売上"
    }
  }), _c('span', [_vm._v("集計-売上")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'accounting') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/paymentdetails"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-自社割賦"
    }
  }), _c('span', [_vm._v("集計-自社割賦")])])], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.keiri) ? [(_vm.user.type === 'admin' || _vm.user.type === 'owner' || _vm.user.type === 'accounting' || _vm.user.type === 'mgr') ? [_c('li', [_c('router-link', {
    staticClass: "child",
    attrs: {
      "to": "/aggregates/agreements"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-line-chart",
    attrs: {
      "title": "集計-売上-販売価格"
    }
  }), _c('span', [_vm._v("集計-売上-販売価格")])])], 1)] : _vm._e()] : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "child",
    attrs: {
      "href": "http://153.126.169.95/users/sign_up"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    attrs: {
      "title": "User登録"
    }
  }), _c('span', [_vm._v("ユーザー登録")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://153.126.169.95/student_tutors/search?limit=30",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "報告書管理"
    }
  }), _c('span', [_vm._v("報告書管理")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://153.126.169.95/student_tutors/?limit=30",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-file-pdf-o",
    attrs: {
      "title": "指導情報"
    }
  }), _c('span', [_vm._v("指導情報")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/kenshus"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-leanpub",
    attrs: {
      "title": "スケジュール"
    }
  }), _c('span', [_vm._v("スケジュール")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://neo-print.masterminds.jp/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-leanpub",
    attrs: {
      "title": "AP封筒印刷"
    }
  }), _c('span', [_vm._v("AP封筒印刷")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "child",
    attrs: {
      "href": "/contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-money",
    attrs: {
      "title": "台帳"
    }
  }), _c('span', [_vm._v("台帳")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee610312"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/common/Menu.vue
// module id = 1481
// module chunks = 0